import { BreakerApplication } from './BreakerTypes';
import type { UnitInfoBreakerInterface } from 'store/units/types';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export class BreakerConfig extends BaseUnitConfig {
  static getDefaultData(_params?: UnitConfigParams): UnitInfoBreakerInterface {
    return {
      ...BaseUnitConfig.getBaseDefaults(),
      attachmentTool: {
        boom: undefined,
        breaker: undefined,
        enabled: true,
        powerPack: undefined,
        application: BreakerApplication.JAW_CRUSHER,
      },
      display: {},
    };
  }

  static getNumberOfPorts(_model?: string, _config?: number): number {
    return 2;
  }
}

export const breakerConfig = new BreakerConfig();
